import { AxiosInstance } from 'axios';
import { Account } from '@trukt/types/Account';
import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { Contact } from '@trukt/types/Contact';
import { User } from '@trukt/types/User';

export type JobDispatchCarrierGetRequest = string;

export type JobDispatchCarrierGetResponse = {
  dispatcher: Pick<User, 'guid' | 'name' | 'email'>;
  vendor: Account;
  vendorAgent: Contact;
};

export class JobDispatchCarrierService implements Pick<BaseRequestEndpoints, 'getById'> {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  getById(jobGuid: JobDispatchCarrierGetRequest) {
    return this.instance.get<JobDispatchCarrierGetResponse>(`/job/${jobGuid}/dispatch/carrier`);
  }
}
